<template>
  <div>
    <b-modal
      title="銷帳"
      size="xl"
      centered
      hide-footer
      header-class="head-modal"
      :no-close-on-backdrop="true"
      v-model="modalShow"
    >
      <b-alert show variant="warning">
        已勾選總計：{{ tickedTotal }}
      </b-alert>

      <tables-page
       :tableData="data.details"
        :tableFields="unPaidBill.table_fields"
      >
        <template #cell(checkbox)="row">
           <b-form-checkbox v-model="row.item.checkbox"></b-form-checkbox>
        </template>

        <template #cell(payment_at)="row">
          <date-picker
            v-model="row.item.payment_at"
            :position="'left'"
          ></date-picker>
        </template>

        <template #cell(payment_source)="row">
          <b-form-select
            v-model="row.item.payment_source"
            :options="options.payment"
            text-field="label"
            value-field="label" />
        </template>

        <template #cell(type)="row">
           <span :class="getBillTypeColor(row.item.type)">{{ getBillFeeDescription(row.item) }}</span>
        </template>

        <template #cell(dead_at)="row">
          {{ convertRocDate(row.item.dead_at) }}
        </template>

        <template #cell(updated_at)="row">
          {{ convertRocDate(row.item.updated_at) }}
        </template>
      </tables-page>

      <div class="text-center mt-4">
        <b-button
          class="mr-2"
          variant="success"
          size="sm"
          @click="sumit"
        >
          確定
        </b-button>

        <b-button
          variant="danger"
          size="sm"
          class="mr-4"
          @click="$emit('change', false)"
        >
          取消
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import datePicker from '@/components/common/DatePicker';
import { convertRocDate, getBillTypeColor, getBillFeeDescription } from "@/models/HELPERS/common.js";

export default {
  name: 'RemoveBillModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    TablesPage,
    datePicker
  },
  data () {
    return {
      options: {
        payment: [
          {
            label: '現金',
            value: 0
          },
          {
            label: '超商',
            value: 1
          },
          {
            label: '新光',
            value: 2
          },
          {
            label: '萬事達',
            value: 3
          },
          {
            label: '郵局臨櫃',
            value: 4
          },
          {
            label: '郵局劃撥',
            value: 5
          },
          {
            label: '網路ATM',
            value: 6
          },
          {
            label: '台中銀行',
            value: 7
          },
          {
            label: '支票',
            value: 8
          },
          {
            label: '自動',
            value: 9
          },
          {
            label: '年費抵用券',
            value: 10
          },
        ]
      },
      unPaidBill: {
        table_fields: [
          {
            key: "checkbox",
            label: "銷帳",
          },
          {
            key: "payment_at",
            label: "繳款日期",
          },
          {
            key: "payment_source",
            label: "繳款來源",
          },
          {
            key: "month",
            label: "帳單月份",
          },
          {
            key: "period",
            label: "帳單期別",
          },
          {
            key: "type",
            label: "類型",
          },
          {
            key: "amount",
            label: "互助金",
          },
          {
            key: "remark",
            label: "備註"
          },
          {
            key: "dead_at",
            label: "繳款期限",
          },
          {
            key: "updated_at",
            label: "異動時間",
          }
        ],
        table_data: [],
      },
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
    tickedTotal() {
      if (!this.data.details) return 0;

      const total = this.data.details.reduce((accumulator, currentValue) => {
        return currentValue.checkbox ? accumulator + Number(currentValue.amount) : accumulator
      }, 0);

      return total;
    }
  },
  watch: {
    show: {
      handler(newValue, oldValue) {

      },
      immediate: false
    }
  },
  mounted() {

  },
  methods: {
    convertRocDate,
    getBillTypeColor,
    getBillFeeDescription,
    sumit() {
      this.$emit('sumit', this.data.details);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/RemoveBillModal.vue